<template>
  <div id="remplacements">
    <router-link to="/cinestaff">
      <img class="imgicon" src="img/back.png" />
    </router-link>
    <h2>Remplacements</h2>
    <hr />
    <h3>Demandes de remplacement</h3>
    <div v-if="demandesATraiter.length > 0"><p>Action groupée</p>
    <button @click="accepterRefuserAll(true)" class="btn btn-success mr-3 btn-sm" title="Accepter">
      <font-awesome-icon :icon="'check'" />
    </button>
    <button @click="accepterRefuserAll(false)" class="btn btn-danger mr-3 btn-sm" title="Refuser">
      <font-awesome-icon :icon="'times'" />
    </button>
    <button class="btn btn-info mr-3  btn-sm" @click="selectAll(true)">Tout cocher</button>
    <button class="btn btn-info mr-3 btn-sm" @click="selectAll(false)">Tout décocher</button>
    </div>
    <b-pagination
      v-if="demandesATraiter.length > 0"
      class="mt-3"
      v-model="currentPageATraiter"
      :total-rows="demandesATraiter.length"
      :per-page="perPageATraiter"
      aria-controls="table-a-traiter"
      align="fill"
      :limit="15"
      size="sm"
    >
      <template v-slot:page="{ page, active }">
        <span style="color:white;" v-if="active">{{ page }}</span>
        <span v-else>{{ page }}</span>
      </template>
    </b-pagination>
    <b-table
      responsive="sm"
      :items="demandesATraiter"
      :fields="fieldsATraiter"
      :per-page="perPageATraiter"
      :current-page="currentPageATraiter"
      class="mt-3"
      id="table-a-traiter"
      v-if="demandesATraiter.length > 0"
      small
      :sort-by.sync="sortByATraiter"
      :sort-desc.sync="sortDescATraiter"
      sort-icon-left
    >
      <template v-slot:table-colgroup="scope">
        <col v-for="field in scope.fields" :key="field.key" :width="'12.5%'" />
      </template>
      <template v-slot:cell(horaire.date)="data">{{utils.toPrettyDate(data.item.horaire.date)}}</template>
      <template v-slot:cell(horaire.id_site)="data">{{sitesById[data.item.horaire.id_site].nom}}</template>
      <template
        v-slot:cell(horaire.id_fonction)="data"
      >{{fonctionsById[data.item.horaire.id_fonction].nom}}</template>
      <template v-slot:cell(seances)="data">
        <seances :item="data.item.horaire"/>
      </template>
      <template v-slot:cell(status)="data">
        <span v-if="data.item.status === 0" class="badge badge-danger">En attente de proposition</span>
        <span v-if="data.item.status === 1" class="badge badge-warning">En attente de validation</span>
        <span v-if="data.item.status === 2" class="badge badge-success">Validé</span>
        <span v-if="data.item.status === 3" class="badge badge-danger">Refusé</span>
        <span v-if="data.item.status === 4" class="badge badge-danger">Annulé</span>
      </template>
      <template
        v-slot:cell(demandeur)="data"
      >{{employesById[data.item.horaire.id_employe].prenom}} {{employesById[data.item.horaire.id_employe].nom}}</template>
      <template v-slot:cell(remplacant)="data">
        <span
          v-if="data.item.id_remplacant"
        >{{employesById[data.item.id_remplacant].prenom}} {{employesById[data.item.id_remplacant].nom}}</span>
        <span v-else>-</span>
      </template>
      <template v-slot:cell(actions)="data">
        <button
          @click="accepterRefuser(data.item, true)"
          v-bind:disabled="!(data.item.status === 1)"
          class="btn btn-success btn-sm"
          title="Accepter"
        >
          <font-awesome-icon :icon="'check'" />
        </button>
        <button
          v-bind:disabled="!(data.item.status === 1)"
          @click="accepterRefuser(data.item, false)"
          class="btn btn-danger btn-sm"
          title="Refuser"
        >
          <font-awesome-icon :icon="'times'" />
        </button>
        {{data.item.selected}}
        <input
          v-bind:disabled="!(data.item.status === 1)"
          type="checkbox"
          v-bind:value="data.item.id"
          v-model="selected"
        />
      </template>
    </b-table>
    <p v-else>Rien à signaler...</p>
    <hr />
    <h3>Archives</h3>
    <b-pagination
      v-if="demandesArchives.length > 0"
      class="mt-3"
      v-model="currentPageArchives"
      :total-rows="demandesArchives.length"
      :per-page="perPageArchives"
      aria-controls="table-archives"
      align="fill"
      :limit="15"
      size="sm"
    >
      <template v-slot:page="{ page, active }">
        <span style="color:white;" v-if="active">{{ page }}</span>
        <span v-else>{{ page }}</span>
      </template>
    </b-pagination>
    <b-table
      responsive="sm"
      :items="demandesArchives"
      :fields="fieldsArchives"
      :per-page="perPageArchives"
      :current-page="currentPageArchives"
      class="mt-3"
      id="table-archives"
      v-if="demandesArchives.length > 0"
      small
      :sort-by.sync="sortByArchives"
      :sort-desc.sync="sortDescArchives"
      sort-icon-left
    >
      <template v-slot:table-colgroup="scope">
        <col v-for="field in scope.fields" :key="field.key" :width="'14.2%'" />
      </template>
      <template v-slot:cell(horaire.date)="data">{{utils.toPrettyDate(data.item.horaire.date)}}</template>
      <template v-slot:cell(horaire.id_site)="data">{{sitesById[data.item.horaire.id_site].nom}}</template>
      <template
        v-slot:cell(horaire.id_fonction)="data"
      >{{fonctionsById[data.item.horaire.id_fonction].nom}}</template>
      <template v-slot:cell(ceances)="data">
        <seances :item="data.item"/>
      </template>
      <template v-slot:cell(status)="data">
        <span v-if="data.item.status === 0" class="badge badge-danger">En attente de proposition</span>
        <span v-if="data.item.status === 1" class="badge badge-warning">En attente de validation</span>
        <span v-if="data.item.status === 2" class="badge badge-success">Validé</span>
        <span v-if="data.item.status === 3" class="badge badge-danger">Refusé</span>
        <span v-if="data.item.status === 4" class="badge badge-danger">Annulé</span>
      </template>
      <template
        v-slot:cell(demandeur)="data"
      ><span v-if="data.item.id_demandeur">{{employesById[data.item.id_demandeur].prenom}} {{employesById[data.item.id_demandeur].nom}}</span><span v-else>-</span></template>
      <template v-slot:cell(remplacant)="data">
        <span
          v-if="data.item.id_remplacant"
        >{{employesById[data.item.id_remplacant].prenom}} {{employesById[data.item.id_remplacant].nom}}</span>
        <span v-else>-</span>
      </template>
    </b-table>
    <p v-else>Rien à signaler...</p>
  </div>
</template>

<script>
import utils from "@/utils";
import api from "@/api";
import Swal from "sweetalert2";
import moment from "moment";
import Seances from "../components/Seances";

export default {
  data() {
    return {
      demandes: [],
      selected: [],
      utils,
      employes: [],
      employesById: [],
      sites: [],
      sitesById: [],
      fonctions: [],
      fonctionsById: [],
      perPageArchives: 15,
      currentPageArchives: 1,
      sortByArchives: "",
      sortDescArchives: false,
      fieldsArchives: [
        { key: "horaire.date", label: "Date", sortable: true },
        { key: "horaire.id_site", label: "Site", sortable: true },
        { key: "horaire.id_fonction", label: "Fonction", sortable: true },
        { key: "seances", label: "Séances", sortable: false },
        { key: "status", label: "Status", sortable: true },
        { key: "demandeur", label: "Demandeur", sortable: false },
        { key: "remplacant", label: "Remplaçant", sortable: false }
      ],
      perPageATraiter: 7,
      currentPageATraiter: 1,
      sortByATraiter: "",
      sortDescATraiter: false,
      fieldsATraiter: [
        { key: "horaire.date", label: "Date", sortable: true },
        { key: "horaire.id_site", label: "Site", sortable: true },
        { key: "horaire.id_fonction", label: "Fonction", sortable: true },
        { key: "seances", label: "Séances", sortable: false },
        { key: "status", label: "Status", sortable: true },
        { key: "demandeur", label: "Demandeur", sortable: false },
        { key: "remplacant", label: "Remplaçant", sortable: false },
        { key: "actions", label: "Actions", sortable: false }
      ]
    };
  },
  components: { Seances },
  async created() {
    this.$store.commit("setLoading", true);
    this.employes = (await api.getEmployes()).data.employes;
    for (let employe of this.employes) {
      this.employesById[employe.id] = employe;
    }
    this.sites = (await api.getSites()).data.sites;
    for (let site of this.sites) {
      this.sitesById[site.id] = site;
    }
    this.fonctions = (await api.getFonctions()).data.fonctions;
    for (let fonction of this.fonctions) {
      this.fonctionsById[fonction.id] = fonction;
    }
    this.demandes = (await api.getAllRemplacements()).data.remplacements;
    this.$store.commit("setLoading", false);
  },
  computed: {
    demandesATraiter() {
      return this.demandes.filter(demande => {
        return !(
          demande.status === 2 ||
          demande.status === 3 ||
          demande.status === 4 ||
          moment(demande.horaire.date).isBefore(moment(), "day")
        );
      });
    },
    demandesArchives() {
      return this.demandes.filter(demande => {
        return (
          demande.status === 2 ||
          demande.status === 3 ||
          demande.status === 4 ||
          moment(demande.horaire.date).isBefore(moment(), "day")
        );
      });
    }
  },
  methods: {
    async accepterRefuser(demande, accepter) {
      let response = await api.accepterRefuserRemplacement(
        demande.id,
        accepter
      );
      if (response.code === 200) {
        demande.status = accepter ? 2 : 3;
      } else {
        Swal.fire({
          type: "error",
          text: response.message
        });
      }
      this.$store.dispatch('updateStats');
    },
    accepterRefuserAll(accepter) {
      for (let select of this.selected) {
        let demande = undefined;
        for (let d of this.demandes) {
          if (d.id === select) {
            demande = d;
            break;
          }
        }
        if (demande) {
          this.accepterRefuser(demande, accepter);
        }
      }
      this.selected = [];
      this.$store.dispatch('updateStats');
    },
    selectAll(select) {
      if (select) {
        for (let demande of this.demandes) {
          if (demande.status === 1) this.selected.push(demande.id);
        }
      } else {
        this.selected = [];
      }
    }
  }
};
</script>